import React from "react";

import Form from "@/components/Form";
import LocaleText from "@/components/Intl/LocaleText";

import { TPersonalizationStepForm } from "./interfaces";
import Layout from "./Layout";

const Pollution: React.FC<TPersonalizationStepForm> = ({ formRef }) => {
  return (
    <Layout title="form.personalizationStep.pollution.title">
      {[true, false].map((value, i) => (
        <Form.RadioButton
          key={i}
          name="pollution"
          value={value}
          onChanged={() => {
            formRef.current!.next();
          }}
        >
          <LocaleText>{"form.personalizationStep.radio." + value}</LocaleText>
        </Form.RadioButton>
      ))}
    </Layout>
  );
};

export default Pollution;
